import { render, staticRenderFns } from "./wallet-history.vue?vue&type=template&id=4f725688&scoped=true&"
import script from "./wallet-history.vue?vue&type=script&lang=js&"
export * from "./wallet-history.vue?vue&type=script&lang=js&"
import style0 from "./wallet-history.vue?vue&type=style&index=0&id=4f725688&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f725688",
  null
  
)

export default component.exports